'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "value", "label", "index", "children", "onClick"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { getDataAttributes } from "../internals/getDataAttributes.js";
import { useSuggestionsContext } from "./internals/SuggestionsContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const SuggestionItem = /*#__PURE__*/React.forwardRef(function SuggestionItem(props, ref) {
  const {
      slots,
      slotProps,
      value,
      label,
      index = 0,
      children,
      onClick
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const context = useSuggestionsContext();
  const displayLabel = label ?? value;
  const ownerState = React.useMemo(() => ({
    value,
    label: displayLabel,
    index
  }), [value, displayLabel, index]);
  const handleClick = React.useCallback(event => {
    onClick?.(event);
    if (!event.defaultPrevented) {
      context?.onSelect(value);
    }
  }, [context, onClick, value]);
  const Root = slots?.root ?? 'button';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: _extends({
      ref,
      type: 'button',
      onClick: handleClick
    }, getDataAttributes({
      index
    }))
  });
  return /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
    children: children ?? displayLabel
  }));
});
if (process.env.NODE_ENV !== "production") SuggestionItem.displayName = "SuggestionItem";